import { useMemo } from "react"
import { yAxisLabelFontSize } from "../GraphContext"
import { useGetMgdlAsTopPosition } from "../useGetMgdlAsTopPosition"
import styles from "./YAxisLabel.module.scss"
import { useReadableGlucoseValue } from "src/hooks"

interface Props {
  value: number;
}

const labelStyle = {
  fontSize: yAxisLabelFontSize,
}

/*
 * the text that labels the glucose value for a particular height along the Y axis
 */
export function YAxisLabel(props: Props) {
  const { value } = props
  const getMgdlAsTopPosition = useGetMgdlAsTopPosition()
  const [topPosition] = getMgdlAsTopPosition(value)
  const valueLabel = useReadableGlucoseValue(value)

  const containerStyle = useMemo(
    () => ({ top: topPosition }),
    [topPosition],
  )

  return (
    <div
      className={styles.container}
      style={containerStyle}
      id="y-axis-ranges"
    >
      <div
        className={styles.label}
        style={labelStyle}
      >
        {valueLabel}
      </div>
    </div>
  )
}
